import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../base/BaseComponent";
import TreeModule from "./component/treeModule";
import {Icon} from "antd";
import SelectedList from "./component/selectedList";

/**
 * creat by tianruojun
 * 选部门组件（树形）
 * @description 一个用来选部门的弹窗组件，可以设置回显和返回选择的部门
 * @class TreeModuleBySelectDept
 * @extends {BaseComponent}
 */
const getTree = "/cm-sites-sys/dept/getTree";
export default class TreeModuleBySelectDept extends BaseComponent {
    static propTypes = {
        /**
         * @text 初始部门id
         * @category data
         */
        deptId: PropTypes.string,
        /**
         * @text 组件宽度
         * @category data
         */
        width: PropTypes.number,
        /**
         * @text 组件高度
         * @category data
         */
        height: PropTypes.number,
        /**
         * @text 数据转义(key:需要的参数；value：取值）
         * @category data
         */
        columnFormat: PropTypes.object,
        /**
         * @text 显示左侧搜索框
         * @category data
         */
        showLeftSearch: PropTypes.bool,
        /**
         * @text 显示右侧搜索框
         * @category data
         */
        showRightSearch: PropTypes.bool,
        /**
         * @text 显示右侧搜索框
         * @category data
         */
        showRight: PropTypes.bool,
        /**
         * @text 点击弹窗确认按钮后的回调
         * @category event
         */
        onSelect: PropTypes.func
    };
    static defaultProps = {
        deptId: '0',
        width: 720,
        height: 630,
        showRight: true,
        showLeftSearch: true,
        showRightSearch: true,
        columnFormat: {
            key: 'id',
            title: 'name',
            children: 'child',
        },
        onSelect: (dept, call) => {
            console.log("选中的部门数据========", dept);
            call && call(true)
        },
    };

    constructor(props) {
        super(props);
        this.state = {
            /**
             * @text 所有部门列表
             * @category arr
             */
            allDeptList: [],
            /**
             * @text 选中的部门列表
             * @category arr
             */
            selectList: [],
            /**
             * @text 勾选的部门列表
             * @category arr
             */
            checkList: [],
        }
    }

    componentWillMount() {
        // 获取所有部门列表
        this.getDeptList(this.props.deptId);
    }

    componentDidMount() {
    }

    /**
     * 获取选择的部门列表
     * @param {fun} 将选择的部门数据回调给函数
     */
    getSelectList = (call) => {
        call && call(this.backTree(this.state.selectList))
    };

    /**
     * 获取选择的部门列表
     * @param {fun} 将选择的部门数据回调给函数
     */
    setSelectList = (selectList) => {
        let list = this.setTree(selectList);
        this.setState({selectList: list,checkList: list})
    };

    /**
     * 设置选择的部门列表
     * @param {array} 传入选中的数据并覆盖已选数据
     */
    onCheck = (checkListKeys, checkList) => {
        this.setState({checkList})
    };

    render() {
        let {height, width, showRight, showLeftSearch, showRightSearch} = this.props;
        return (
            <div className={'TreeModule'} style={{display: 'flex', height: height, width: width, background: '#FFF'}}>
                {this.renderLeft()}
                {showRight ? this.renderRight() : null}
                <style>
                    {`
                        .TreeModule .ant-input {
                            background: #f5f8fc;
                        }
                    `}
                </style>
            </div>
        )
    }

    /**
     * 渲染左侧树结构
     */
    renderLeft = () => {
        let {height, width, showRight, showLeftSearch} = this.props;
        let {allDeptList, selectList=[],checkList=[]} = this.state;
        return <TreeModule
            height={height}
            width={width}
            showRight={showRight}
            showLeftSearch={showLeftSearch}
            treeData={allDeptList}
            checkedKeys={checkList?.map(item=>item.key)||[]}
            onCheck={this.onCheck}
        />
    };

    /**
     * 渲染右侧列表及穿梭框
     */
    renderRight = () => {
        return <>
            {this.renderShuttle()}
            {this.renderSelectedList()}
        </>
    };

    /**
     * 渲染右侧列表
     */
    renderSelectedList = () => {
        let {showRightSearch,height} = this.props;
        let {selectList} = this.state;
        return <SelectedList
            data={selectList}
            height={height}
            showRightSearch={showRightSearch}
            onSelect={(list) => {
                this.setState({selectList:list});
                console.log("list=======", list)
            }}
        />
    };

    /**
     * 渲染穿梭框
     */
    renderShuttle = () => {
        return <div style={{width: 55, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <div
                style={{
                    width: ' 24px',
                    height: '24px',
                    background: '#0050B3',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    cursor: "pointer",
                    borderRadius: '2px'
                }}
                onClick={() => {
                    this.setState({selectList: this.state.checkList})
                }}
            >
                <Icon type="right"/>
            </div>
        </div>
    };

    /**
     * 获取所有部门列表
     * @param {string} id 最外层部门id，不设置则为‘0’，默认为全部
     */
    getDeptList = (id = "") => {
        this.request({
            url: getTree,
            body: {id},
            callBack: (res) => {
                let allDeptList = [];
                if (res) {
                    allDeptList = [res];
                }
                this.setState({allDeptList: this.setTree(allDeptList)}, () => {
                    console.log("allDeptList===========", this.state.allDeptList)
                    // console.log("反转义数据==========",this.backTree(this.state.allDeptList))
                })
            },
            errorCallBack: (e) => {
                this.setState({allDeptList: []})
            }
        })
    };

    /**
     * 数据转义
     * @param {array} 树数据
     */
    setTree = (tree) => {
        let format = this.props.columnFormat;
        if (!format || !(tree && tree.length)) {
            return tree;
        }
        return tree.map(item => {
            let newItem = {};
            for (let i in format) {
                newItem[i] = item[format[i]]
            }
            if (newItem.children && newItem.children.length) {
                newItem.children = this.setTree(newItem.children)
            }
            return newItem
        });
    };

    /**
     * 数据反转义
     * @param {array} 树数据
     */
    backTree = (tree) => {
        let format = this.props.columnFormat;
        if (!format || !(tree && tree.length)) {
            return tree;
        }
        return tree.map(item => {
            let newItem = {};
            for (let i in format) {
                newItem[format[i]] = item[i]
            }
            if (newItem[format.children] && newItem[format.children].length) {
                newItem[format.children] = this.setTree(newItem[format.children])
            }
            return newItem
        });
    };


}